// extracted by mini-css-extract-plugin
export var markdown = "Markdown-module--markdown--pVzCO";